import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
import { AppTranslateService } from "src/app/core/service/app-translate.service";
import { AuthService } from "src/app/core/service/auth.service";
import { MustMatch } from "src/app/_helpers/must-match.validator";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  public forgotForm: FormGroup;
  public pwdForm: FormGroup;
  public submitted = false;

  public email: string = '';
  public confirmToken: string = '';

  // <!-- Property declaration -->
  public fieldTextType1: boolean;
  public fieldTextType2: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router,
    private appTranslateService: AppTranslateService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.get("email") && params.get("token")) {
        this.email = params.get("email");
        let token = params.get("token");
        token  = token.toString().replace(/ /g,"+");
        this.confirmToken = decodeURIComponent(token); // decode token from url
        this.createPwdForm();
      } else {
        this.createForm();
      }
    });
  }

  createPwdForm() {
    this.pwdForm = this.formBuilder.group(
      {
        email: [this.email, [Validators.required, Validators.email]],
        newPassword: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: MustMatch("newPassword", "confirmPassword")
      }
    );
  }

  createForm() {
    this.forgotForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  // <!-- Switching method -->
  toggleFieldTextType(num) {
    if (num === 1) {
      this.fieldTextType1 = !this.fieldTextType1;
    } else if (num === 2) {
      this.fieldTextType2 = !this.fieldTextType2;
    }
  }

  // convenience getter for easy access to form fields
  get p() {
    return this.pwdForm.controls;
  }
  get f() {
    return this.forgotForm.controls;
  }


  onGetPassword() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.forgotForm.invalid) {
      return;
    }

    let passwordData =  {
      "Email": this.forgotForm.controls.email.value,
      "UserName": this.forgotForm.controls.email.value,
      "ResetUrl": "/Auth/ForgotPassword",
    }

    this.authService
      .forgotPassword(passwordData)
      .pipe(take(1))
      .subscribe(
        (res) => {
            if (this.appTranslateService.currentLang() == "sv") {
              this.toastr.success("Din begäran fortsätt kolla din e-post!", "Framgång", {
                timeOut: 2000,
              });
            } else {
              this.toastr.success("Your request proceed check your mail!", "Success", {
                timeOut: 2000,
              });
            }

            this.router.navigate(["/Auth/Login"]);
          },
        (err) => {
          if (err.status === 401) {
            if (this.appTranslateService.currentLang() == "en") {
              this.toastr.error("Email is not valid!", "Error", {
                timeOut: 2000,
              });
            } else {
              this.toastr.error("E-post är inte giltig!", "Fel", {
                timeOut: 2000,
              });
            }
          }
        }
      );
  }

  onResetPassword() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.pwdForm.invalid) {
      return;
    }

    let passwordData ={
      "Email": this.email,
      "UserName": this.email,
      "Token": this.confirmToken,
      "Password": this.pwdForm.controls.newPassword.value
    };

    this.authService
      .resetPassword(passwordData)
      .pipe(take(1))
      .subscribe(
        (res) => {
          if (this.appTranslateService.currentLang() == "sv") {
            this.toastr.success("Ditt lösenord återställs, använd nytt lösenord för inloggning!", "Framgång", {
              timeOut: 2000,
            });
          } else {
            this.toastr.success("Your password reset, use new password for login!", "Success", {
              timeOut: 2000,
            });
          }

          this.router.navigate(["/Auth/Login"]); 
        },
        (err) => {
        }
      );
  }
}
